<div class="yt-report-enum-select-v2" [class.is-open]="open" [class.is-disabled]="disabled" [class.is-invalid]="invalid">
  <button
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    type="button"
    class="yt-report-enum-trigger-v2"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    [attr.aria-expanded]="open"
    aria-haspopup="listbox"
    (click)="toggle()"
    (keydown)="handleTriggerKeydown($event)"
  >
    <span [class.is-placeholder]="!selectedLabel">{{ selectedLabel || placeholder }}</span>
    <span class="yt-report-enum-actions-v2">
      <span
        *ngIf="allowClear && selectedLabel && !disabled"
        class="yt-report-enum-clear-v2"
        role="button"
        tabindex="0"
        aria-label="Clear selection"
        (click)="clear($event)"
        (keydown.enter)="clear($event)"
        (keydown.space)="clear($event)"
      ><i nz-icon nzType="close-circle" aria-hidden="true"></i></span>
      <i class="yt-report-enum-chevron-v2" nz-icon nzType="down" aria-hidden="true"></i>
    </span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open"
    [cdkConnectedOverlayWidth]="panelWidth"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="10"
    (overlayOutsideClick)="close()"
    (overlayKeydown)="handleKeydown($event)"
    (attach)="handleAttach()"
    (detach)="close()"
  >
    <div #panel class="yt-report-dropdown-panel-v2 yt-report-enum-panel-v2" role="listbox" [attr.aria-label]="ariaLabel">
      <label *ngIf="searchable" class="yt-report-enum-search-v2">
        <i nz-icon nzType="search" aria-hidden="true"></i>
        <input
          type="search"
          [value]="query"
          [placeholder]="searchPlaceholder"
          (input)="searchChanged($any($event.target).value)"
          (keydown)="handleKeydown($event)"
        />
      </label>
      <div class="yt-report-enum-options-v2">
        <button
      *ngFor="let option of filteredOptions; let optionIndex = index; trackBy: trackOption"
          type="button"
          class="yt-report-enum-option-v2"
          role="option"
          [class.is-selected]="isSelected(option)"
          [attr.aria-selected]="isSelected(option)"
          [attr.data-option-index]="optionIndex"
          (click)="select(option)"
          (keydown)="handleKeydown($event)"
        >
          <span>{{ option.label }}</span>
          <i *ngIf="isSelected(option)" nz-icon nzType="check" aria-hidden="true"></i>
        </button>
        <span *ngIf="filteredOptions.length === 0" class="yt-report-enum-empty-v2">{{ noOptionsLabel }}</span>
      </div>
    </div>
  </ng-template>
</div>
